import axios from '@/libs/api.request'
// 查询单个项目的详情
export const getProjectBasicDetail = data => {
  return axios.request({
    url: '/project/basic/detail',
    data,
    method: 'POST'
  })
}
// 学生截止日期
export const getProjectPage = data => {
  return axios.request({
    url: '/project/page',
    data,
    method: 'POST'
  })
}

// 列表接口（查询学校、项目）
export const getProjectList = data => {
  return axios.request({
    url: '/project/list',
    data,
    method: 'POST'
  })
}
